import React from 'react';
import Barcode from 'react-barcode';
import { CheckCircle } from 'lucide-react';

export default function Step4Resumo({
  uniqueCaixas, handlePrint, printedIds, operar, operation,
  registrarButtonRef, isSubmitting
}) {
  return (
    <div className="bg-white rounded-2xl shadow p-6">
      <h3 className="font-medium  mb-4">Lista de Impressão de Etiquetas</h3>
      <div className="flex flex-wrap gap-4 mb-6">
        {uniqueCaixas.map(c => (
          <div key={c.id} className="flex items-center gap-2 bg-gray-50 p-2 rounded-full">
            <span className="font-medium">{c.nome} ({c.qty})</span>
            <button onClick={() => handlePrint(c)} className="no-print">
              <Barcode
                value={String(c.id)}
                format="CODE128"
                width={1}
                height={15}
                displayValue={false}
              />
            </button>
            {printedIds.includes(c.id) && (
              <CheckCircle size={24} className="text-green-500" />
            )}
          </div>
        ))}
      </div>
      <div className="flex justify-end">
        <button
          onClick={() => operar(operation)}
          ref={registrarButtonRef}
          disabled={isSubmitting}
          aria-busy={isSubmitting}
          className={`px-6 py-2 rounded-full text-white ${operation === 'entrada'
            ? 'bg-green-600 hover:bg-green-700'
            : 'bg-red-600 hover:bg-red-700'
            } ${isSubmitting ? 'opacity-60 cursor-not-allowed' : ''}`}
        >
          {isSubmitting ? 'Aguardando…' : `Registrar ${operation === 'entrada' ? 'Entrada' : 'Saída'}`}
        </button>
      </div>
    </div>
  );
}